<template>
  <button class="close dialog-close" @click="hideModal"></button>
</template>

<script>
export default {
  name: "DialogCloseButton",
  props: {
    hideModal: Function
  }
};
</script>

<style lang="scss">
.dialog-close {
  border: 0;
  right: 14px;
  border-radius: 16px;
  background-color: white;
  margin: 10px 10px 0 0;
  @include respond-to-mobile {
    margin: 4px 2px 0 0;
  }

  &:before,
  &:after {
    height: 16px;
    width: 2px;
    background-color: $group-3-color-2;
  }
}
</style>
